<template>
  <v-row>
    <v-col
      cols="12"
      class="py-0 pr-0 pl-2 ml-2 hyp-primary-risk-container"
      :class="{
        well: useClick,
      }"
    >
      <div
        v-for="(risk, index) in risks"
        :key="risk.id + index"
        class="pull-left mr-1 my-1 risk-container"
        :class="{
          'risk-container-active':
            selectedPrimaryRisk &&
            selectedPrimaryRisk.riskCategoryId === risk.id,
          'risk-container-cursor': useClick,
          'risk-container-dark': dark && !useClick,
          'risk-container-vertical': !horizontal,
          'risk-container-horizontal': horizontal,
        }"
        @click="handleClickRiskRating(risk)"
      >
        <div
          class="risk-type-container application-heading"
          :class="{ 'pt-2 pb-1': !horizontal }"
        >
          {{ risk.type.toUpperCase() }}
        </div>
        <div
          :class="{
            'risk-bar-container': !horizontal,
            'risk-bar-container-horizontal': horizontal,
          }"
          :title="getRiskLevel(risk)"
        >
          <div :style="getRiskStyle(risk)" class="risk-bar"></div>
        </div>
        <div class="risk-level-container" :class="{ 'pt-1 pb-2': !horizontal }">
          {{ getRiskLevel(risk) }}
        </div>
      </div>
      <div class="clearfix"></div>
    </v-col>
  </v-row>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";

import { RISK_LEVELS } from "@/common/constants/controlRisks/risks";

const EMITTED_ACTIONS = {
  CLICK: "click",
};

export default {
  name: "RiskRatingPrimary",
  components: {},
  props: {
    risks: {
      type: Array,
    },
    useClick: {
      type: Boolean,
      default: true,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    selectedPrimaryRisk: {
      type: Object,
      required: false,
    },
    selectedSubRisk: {
      type: Object,
      required: false,
    },
    parentRatings: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      riskTypesPrimary: null,
    };
  },
  methods: {
    getRiskLevel(risk) {
      if (risk && risk.value) {
        const rating = lodashFind(RISK_LEVELS, ["value", risk.value]);
        return lodashGet(rating, "name");
      }
      return null;
    },
    getRiskStyle(risk) {
      let isSameAsParent = false;
      const id = risk.id;
      const level = risk.value;
      for (
        let i = 0;
        this.parentRatings && i < this.parentRatings.length;
        i++
      ) {
        const checkLevel = this.parentRatings[i].rateValue;
        const checkId = this.parentRatings[i].riskCategoryId;
        if (id === checkId && level === checkLevel) {
          isSameAsParent = true;
        }
      }
      if (risk && risk.value) {
        const rating = lodashFind(RISK_LEVELS, ["value", risk.value]);
        const color = isSameAsParent ? "#CBCBCB" : lodashGet(rating, "bgColor");

        if (!this.horizontal) {
          return {
            "background-color": color,
            height: "10px",
            width: `${55 * (risk.value / RISK_LEVELS.length)}px`,
            margin: "auto",
          };
        }
        return {
          "background-color": color,
          top: "5px",
          height: "10px",
          width: "70px",
        };
      }
      return null;
    },
    handleClickRiskRating(risk) {
      if (this.useClick) {
        this.$emit(EMITTED_ACTIONS.CLICK, risk, false);
      }
    },
  },
};
</script>

<style scoped>
.risk-container {
  background-color: white;
  font-size: 12px;
  border-radius: 4px;
}
.risk-container-vertical {
  width: 75px;
  height: 75px;
  font-size: x-small;
}
.risk-container-horizontal {
  width: 90px;
  height: 46px;
  margin-right: 0 !important;
}
.risk-container-dark {
  background-color: rgba(0, 0, 0, 0) !important;
}
.risk-container-cursor {
  cursor: pointer;
}
.risk-container-active {
  border: 1px solid rgb(107, 107, 107);
}
.risk-type-container {
  width: 100%;
  text-align: center;
}
.risk-bar-container {
  position: relative;
  height: 10px;
}
.risk-bar-container-horizontal {
  margin-left: 10px;
  position: relative;
  width: 60px;
}
.risk-bar-container-horizontal .risk-bar {
  border-radius: 4px;
}
.risk-bar {
  width: 100%;
  border-radius: 10px;
}
.risk-level-container {
  width: 100%;
  text-align: center;
}
.well {
  background-color: rgb(231, 231, 231);
  border-radius: 5px;
}
</style>
